import React, { useState, useEffect } from 'react';
import { adminAPI } from '../../services/api';
import {
  CCard,
  CCardBody,
  CCardHeader,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
  CBadge,
  CInputGroup,
  CFormInput,
  CButton
} from '@coreui/react';
import { useTranslation } from 'react-i18next';
import CIcon from '@coreui/icons-react';
import { cilSearch } from '@coreui/icons';

const AdminRides = () => {
  const { t } = useTranslation();
  const [rides, setRides] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  const loadRides = async () => {
    setLoading(true);
    try {
      const response = await adminAPI.getRides({ search: searchTerm });
      setRides(response.data.rides || []);
    } catch (error) {
      console.error('Failed to load rides:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      loadRides();
    }, 300);
    return () => clearTimeout(timeoutId);
  }, [searchTerm]);

  const getStatusBadge = (status) => {
    const statusMap = {
      scheduled: { color: 'warning', label: t('schedule.scheduled') },
      inProgress: { color: 'info', label: t('schedule.inProgress') },
      completed: { color: 'success', label: t('schedule.completed') },
      cancelled: { color: 'danger', label: t('schedule.cancelled') }
    };
    const statusInfo = statusMap[status] || { color: 'secondary', label: status };
    return <CBadge color={statusInfo.color}>{statusInfo.label}</CBadge>;
  };

  // Rides are already filtered by API

  return (
    <div className="admin-rides">
      <CCard>
        <CCardHeader className="d-flex justify-content-between align-items-center">
          <h2 className="admin-page-title mb-0">{t('admin.rides') || 'Rides'}</h2>
          <CInputGroup style={{ width: '300px' }}>
            <CFormInput
              placeholder={t('common.search') || 'Search...'}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <CButton type="button" color="secondary">
              <CIcon icon={cilSearch} />
            </CButton>
          </CInputGroup>
        </CCardHeader>
        <CCardBody>
          <CTable align="middle" className="mb-0 border" hover responsive>
            <CTableHead color="light">
              <CTableRow>
                <CTableHeaderCell>{t('carpools.name')}</CTableHeaderCell>
                <CTableHeaderCell>{t('schedule.driver')}</CTableHeaderCell>
                <CTableHeaderCell>{t('children.title')}</CTableHeaderCell>
                <CTableHeaderCell>{t('schedule.startDate')}</CTableHeaderCell>
                <CTableHeaderCell>{t('schedule.time')}</CTableHeaderCell>
                <CTableHeaderCell>{t('schedule.status')}</CTableHeaderCell>
              </CTableRow>
            </CTableHead>
            <CTableBody>
              {rides.map((ride) => (
                <CTableRow key={ride.id}>
                  <CTableDataCell>
                    <div className="fw-bold">{ride.carpoolName}</div>
                  </CTableDataCell>
                  <CTableDataCell>
                    <div>{ride.driverName}</div>
                  </CTableDataCell>
                  <CTableDataCell>
                    <div>{ride.childName}</div>
                  </CTableDataCell>
                  <CTableDataCell>
                    <div>{new Date(ride.scheduledDate).toLocaleDateString()}</div>
                  </CTableDataCell>
                  <CTableDataCell>
                    <div>{ride.scheduledTime}</div>
                  </CTableDataCell>
                  <CTableDataCell>
                    {getStatusBadge(ride.status)}
                  </CTableDataCell>
                </CTableRow>
              ))}
            </CTableBody>
          </CTable>
          
          {rides.length === 0 && (
            <div className="text-center py-5">
              <p className="text-muted">{t('admin.noRides') || 'No rides found'}</p>
            </div>
          )}
        </CCardBody>
      </CCard>
    </div>
  );
};

export default AdminRides;

